import { useState, useEffect } from 'react';
import { serviceService } from '../services/firebase/serviceService';
import { services as staticServices, getServiceBySlug as getStaticServiceBySlug } from '../data/services';

const USE_FIREBASE = true;

export function useServices() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchServices() {
      try {
        setLoading(true);
        if (USE_FIREBASE) {
          const data = await serviceService.getAll();
          if (data.length > 0) {
            setServices(data);
          } else {
            setServices(staticServices);
          }
        } else {
          setServices(staticServices);
        }
      } catch (err) {
        console.error('Error fetching services:', err);
        setError(err);
        setServices(staticServices);
      } finally {
        setLoading(false);
      }
    }

    fetchServices();
  }, []);

  return { services, loading, error };
}

export function useService(slug) {
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchService() {
      if (!slug) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        if (USE_FIREBASE) {
          const data = await serviceService.getBySlug(slug);
          if (data) {
            setService(data);
          } else {
            const staticService = getStaticServiceBySlug(slug);
            setService(staticService || null);
          }
        } else {
          const staticService = getStaticServiceBySlug(slug);
          setService(staticService || null);
        }
      } catch (err) {
        console.error('Error fetching service:', err);
        setError(err);
        const staticService = getStaticServiceBySlug(slug);
        setService(staticService || null);
      } finally {
        setLoading(false);
      }
    }

    fetchService();
  }, [slug]);

  return { service, loading, error };
}

export default useServices;
